import styled from "styled-components";
import { MOBILE_MIN_WIDTH, TABLET_MAX_WIDTH, TABLET_MIN_WIDTH } from "@constants";

// We must to keep min height in px to provide expected block height for all devices.
export const StyledDiveInActionWrapper= styled.div`
    background-image: url(${({ banner }) => banner}), url(${({ image }) => image}), linear-gradient(90deg,var(--dark-purple) 28%,rgba(0,212,255,1) 200%);
    background-repeat: no-repeat;
    background-position: right bottom;
    width: 100%;
    min-height: 235px;
    padding: 1.25rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    box-sizing: border-box;

    @media only screen and (max-width: ${TABLET_MIN_WIDTH}px) {
        height: max-content;
        padding: 3rem 2.5rem;
    }

    @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        flex-direction: column;
        background: var(--dark-purple);
        padding: 2rem 1.5rem;
        align-items: flex-start;
    }
`;

export const StyledDiveInActionContainer = styled.div`
  max-width: 45%;

  @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
     max-width: 100%;
}
`;

export const StyledTitle = styled.div`
    color: rgba(255, 255, 255, 0.80);
    font-size: 1.75rem;
    line-height: 129.167%;
    font-weight: 700;
    letter-spacing: 0.48px;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        margin-bottom: 1rem;
    }
`;

export const StyledDescription = styled.div`
    color: rgba(255, 255, 255, 0.80);
    font-size: 1rem;
    line-height: 150%;
    letter-spacing: 0.8px;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        margin-bottom: 1.75rem;
    }
    @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        margin-bottom: 2rem;
    }
`;

export const StyledTextContainer = styled.div`
    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        width: auto;
    }
`;

export const StyledButtonContainer = styled.a`
    display: block;
    min-width: 171px;

    word-wrap: break-word;
    white-space: nowrap;
    text-decoration: none;

    margin-top: 20px;    

    .main-button {
      border-color: white;
    }

    .button {
      font-size: 1.3rem;
      color: white;
    }

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        width: 50%;
    }

    @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        width: 100%;
    }

    img {
        height: 1.1rem !important;
        width: 1.1rem !important;
    }
`;

export const StyledCaseTitle = styled.div`
    text-transform: uppercase;
    color: #fff;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
       margin-top: 0.626rem;
    }
`;
